import React, {useCallback, useEffect, useState} from "react";
import {Button, Checkbox, Input, Modal, Select} from "antd"
import {getBands} from "../../bands/bands.service";
import {useInputs} from "../../../hooks/useInputs";
import {InputWrapper, ModalContentWrapper} from "../../common/modal/modal.style";
import accountApi from "../../accounts/accounts.service";
import {getBandLabel, getBandName} from "./collectorProfileView";

const {Option} = Select;

const CollectorCreateModal = ({modalState, setModalState, setForceReload}) => {
  const [loading, setLoading] = useState(false)
  const [bands, setBands] = useState([])
  const [userNameInput, handleUserNameInput] = useInputs("", "input");
  const [emailInput, handleEmailInput] = useInputs("", "input");
  const [passwordInput, handlePasswordInput] = useInputs("", "input");
  const [bandSelect, setBandSelect] = useState("");
  const [multiBandMode, setMultiBandMode] = useState(false);
  const [selectedBandIds, setSelectedBandIds] = useState([]);
  const [defaultBandId, setDefaultBandId] = useState("");

  const bandOptions = bands.map((e, i) => (
    <Option
      key={'band-option-' + i}
      value={e.id}
    >
      {getBandLabel(e)}
    </Option>
  ));

  useEffect(() => {
    getBands().then(r => setBands(r))
  }, [])

  const hideModal = useCallback(() => {
    setModalState({
      isVisible: false,
      modalData: {},
      modalType: "",
    });
  }, []);

  const bandNameOf = (bandId) => getBandName(bands, bandId);

  const handleMultiBandModeChange = (event) => {
    const checked = event.target.checked;
    setMultiBandMode(checked);
    if (checked) {
      const initialBandId = bandSelect || selectedBandIds[0] || "";
      setSelectedBandIds(initialBandId ? [initialBandId] : []);
      setDefaultBandId(initialBandId);
    } else {
      const remainingBandId = defaultBandId || selectedBandIds[0] || "";
      setBandSelect(remainingBandId);
    }
  };

  const handleMultiBandsChange = (bandIds) => {
    setSelectedBandIds(bandIds);
    if (!bandIds.includes(defaultBandId)) setDefaultBandId(bandIds[0] || "");
  };

  const createCollector = async () => {
    const primaryBandId = multiBandMode ? defaultBandId : bandSelect;

    setLoading(true)
    const request = {
      bandId: primaryBandId,
      email: emailInput.replace(/ /g, ""),
      name: userNameInput.replace(/ /g, ""),
      password: passwordInput ? passwordInput : "222222"
    };
    if (multiBandMode) {
      request.bandIds = selectedBandIds;
      request.defaultBandId = defaultBandId;
    }

    return accountApi.createCollector(request).then(() => {
      setLoading(false)
      alert("생성 성공");
      setForceReload();
      hideModal();
    }).catch(() => {
      setLoading(false)
      alert("생성 실패");
      hideModal();
    });
  };

  const handleOnclick = () => {
    const primaryBandId = multiBandMode ? defaultBandId : bandSelect;
    if (!userNameInput || !emailInput || !primaryBandId) return alert("값을 전부 입력해주세요!");
    if (multiBandMode && selectedBandIds.length < 2) return alert("복수 밴드는 두 개 이상 선택해주세요.");
    if (multiBandMode && !selectedBandIds.includes(defaultBandId)) {
      return alert("기본 밴드는 선택한 밴드 중에서 지정해주세요.");
    }

    if (!multiBandMode) return createCollector();

    Modal.confirm({
      title: "복수 밴드 계정으로 생성하시겠습니까?",
      content: `대표 이메일: ${emailInput.replace(/ /g, "")} / 소속 밴드: ${selectedBandIds.map(bandNameOf).join(", ")} / 기본 밴드: ${bandNameOf(defaultBandId)}`,
      okText: "생성",
      cancelText: "취소",
      onOk: createCollector,
    });
  };

  const ModalFooter = () => {
    return <>
      <Button type='default' onClick={hideModal}>취소</Button>
      <Button loading={loading} onClick={handleOnclick} type='primary'>콜랙터 계정
        생성</Button>
    </>
  }

  return (
    <Modal title={'콜랙터 계정 생성'}
           onCancel={hideModal}
           visible={modalState.isVisible}
           forceRender={true}
           footer={<ModalFooter/>}>
      <ModalContentWrapper>
        <InputWrapper>
          <p style={{margin: "0 16px 0 0", minWidth: "55px"}}>유저 이름: </p>
          <Input
            style={{
              width: "300px"
            }}
            value={userNameInput}
            onChange={handleUserNameInput}/>
        </InputWrapper>
        <InputWrapper>
          <p style={{margin: "0 16px 0 0", minWidth: "55px"}}>이메일: </p>
          <Input
            style={{
              width: "300px"
            }}
            value={emailInput}
            onChange={handleEmailInput}/>
        </InputWrapper>
        <InputWrapper>
          <p style={{margin: "0 16px 0 0", minWidth: "55px"}}>패스워드: </p>
          <Input
            style={{
              width: "300px"
            }}
            placeholder="패스워드를 입력해주세요. 비워두시면 222222으로 생성됩니다."
            value={passwordInput}
            onChange={handlePasswordInput}/>
        </InputWrapper>
        <InputWrapper>
          <p style={{margin: "0 16px 0 0", minWidth: "55px"}}>소속 밴드: </p>
          <div style={{display: "flex", alignItems: "center", gap: "12px"}}>
            <Select
              mode={multiBandMode ? "multiple" : undefined}
              style={{width: "300px"}}
              value={multiBandMode ? selectedBandIds : bandSelect || undefined}
              onChange={multiBandMode ? handleMultiBandsChange : setBandSelect}
              showSearch
              placeholder="소속 밴드를 선택해주세요."
              filterOption={(input, option) =>
                String(option.children ?? "").toLowerCase().includes(input.toLowerCase())
              }>
              {bandOptions}
            </Select>
            <Checkbox checked={multiBandMode} onChange={handleMultiBandModeChange}>
              복수 밴드
            </Checkbox>
          </div>
        </InputWrapper>
        {multiBandMode && <InputWrapper>
          <p style={{margin: "0 16px 0 0", minWidth: "55px"}}>기본 밴드: </p>
          <Select
            style={{width: "300px"}}
            value={defaultBandId || undefined}
            onChange={setDefaultBandId}
            placeholder="기본 밴드를 선택해주세요."
          >
            {bands.filter((band) => selectedBandIds.includes(band.id)).map((band) => (
              <Option key={band.id} value={band.id}>{getBandLabel(band)}</Option>
            ))}
          </Select>
        </InputWrapper>}
      </ModalContentWrapper>
    </Modal>
  );
};

export default CollectorCreateModal
